const REGEXP_VALID_EMAIL_ADDRESS = /^[-\w.+]+@([A-zА-яЁё0-9][-A-zА-яЁё0-9]+\.)+[A-zА-яЁё]{2,6}$/i;

export const notEmptyHandler = (field) => {
  if (field.value === '') {
    return 'Пожалуйста, заполните поле';
  }
  return null;
};

export const emailHandler = (field) => {

  const errors = notEmptyHandler(field);
  if (errors != null) {
    return errors;
  } else if (field.value.search(REGEXP_VALID_EMAIL_ADDRESS) === -1) {
    return 'Некорректный email'
  }

  return null;
};

export const phoneHandler = (field) => {
  const phoneReg = /^(\+)?(\d{6,12})$/i;
  const errors = notEmptyHandler(field);
  if (errors != null) {
    return errors;
  } else if (field.value.search(phoneReg) === -1) {
    return 'Некорректный номер телефона'
  }

  return null;
};

export const passwordHandler = (field) => {
  if (field.value.length < 8) {
    return 'Должен быть длиннее 8 символов'
  }
  return null;
};

export const newPasswordHandler = (field) => {
  if (field.value.length !== 0) {
    return passwordHandler(field);
  }
  return null;
};

export const newNotEmptyHandler = (fieldValue) => {
  if (fieldValue === '') {
    return 'Пожалуйста, заполните поле';
  }
  return null;
};

export const newEmailHandler = (fieldValue) => {

  const errors = newNotEmptyHandler(fieldValue);
  if (errors != null) {
    return errors;
  } else if (fieldValue.search(REGEXP_VALID_EMAIL_ADDRESS) === -1) {
    return 'Некорректный email'
  }

  return null;
};



// WEBPACK FOOTER //
// ./src/validators/form-validators.js